var map = {
	"./background-modal-1.svg": 3834,
	"./bitcoin.svg": 694,
	"./cardano.svg": 8784,
	"./cash_back.svg": 4969,
	"./comeback.svg": 4784,
	"./doge.svg": 1802,
	"./shiba.svg": 9042,
	"./trading_voucher.svg": 7758,
	"./tron.svg": 8930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7759;